import React, { useEffect } from "react"
import { Container } from "reactstrap"
import * as s from "./style.module.css"
import Dots from "../Dots/index"
import useLabels from "../../utils/useLabels"
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

import labels from "../Localization/const"

export default function Localization({ lang }) {
  const t = useLabels(labels, lang);

  return (
    <div className={s.root}>
      <Container className="my-3">
        <div className={s.header}>
          <h2>Lokalizacja 2022</h2>
          <div className={s.divider} />
        </div>

        <section className="mb-5" id="gdansk">

          <div className="d-flex flex-column flex-md-row">
          <div class="mr-5">
            <div className={s.header}>
              <h2>{t.gdansk.title}</h2>
              <div className={s.divider} />
            </div>
              <span className={s.address}>
                {t.gdansk.address}
              </span>
               <p className={s.desc}>
                 {t.gdansk.desc}
               </p>
          </div>
          <div>
            <LazyLoadImage alt="lokalizacja" className="rounded-lg" src={require('./images/gdansk.png').default} />
          </div>
          </div>

        </section>

        <section id="slupsk">

          <div className="d-flex flex-column flex-md-row">
            <div class="mr-5">
              <div className={s.header}>
                <h2>{t.slupsk.title}</h2>
                <div className={s.divider} />
              </div>
              <span className={s.address}>
                {t.slupsk.address}
              </span>
              <p className={s.desc}>
                {t.slupsk.desc}
              </p>
            </div>
            <div>
              <img alt="" className="rounded-lg" src={require('./images/slupsk.png').default} />
            </div>
          </div>

        </section>

      </Container>
    </div>
  )
}

function Project({ text, name, image, place, posX, posY }) {
  const dostStyle = {
    position: "absolute",
    top: posX,
    left: posY,
    transform: "scale(1.6)",
    zIndex: 0,
  }

  return (
    <div
      className={[
        s.project,
        name === "ADMD" || name === "Flower Power" || name === "Ekoninja"
          ? s.highlight
          : "",
      ].join(" ")}
    >
      <div className="d-flex">
        <div className={s.imgWrapper}>
          <img alt="" className={s.img} src={image} />
          <div style={dostStyle}>
            <Dots x={4} y={4} color="black" />
          </div>
        </div>
      </div>

      <h4 className={s.projectTitle}>{name}</h4>
      <h5 className={s.place}>{place}</h5>
      <div className={s.text} dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  )
}
